import { searchRegistry } from "../../platform/search/register/search-registry";
import { CalendarCog, FileUser, Settings, SquareMenu } from "lucide-react";

searchRegistry.register([
    {
        id: "settings.leave.types",
        title: "Leave Type Configuration",
        description: "Manage Leave Types",
        route: "/setting/leave-types",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["leave types", "edit","settings"],
        icon: Settings,
        type: 'result'
    },
    {
        id: "settings.qualification",
        title: "Manage Qualification Attributes",
        description: "HR Master Configuration",
        route: "/setting/qualification",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["qualifications","settings"],
        icon: SquareMenu,
        type: 'result'
    },
    {
        id: "settings.work.weeks",
        title: "Manage Work Structure",
        description: "HR Master Configuration",
        route: "/setting/work-week",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["work", "week","settings"],
        icon: CalendarCog,
        type: 'result'
    }, {
        id: "settings.designation",
        title: "Manage Designations Attributes",
        description: "HR Master Configuration",
        route: "/setting/designation",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["design", "designation","settings"],
        icon: FileUser,
        type: 'result'
    }, {
        id: "settings.leave.period",
        title: "Leave Period Configuration",
        description: "HR Master Configuration",
        route: "/setting/leave-period",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["leave period", "time","settings"],
        icon: CalendarCog,
        type: 'result'
    }

]);
